import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-sales-phone-enrollment-manual-questions-process-nuovo',
  templateUrl: './sales-phone-enrollment-manual-questions-process-nuovo.component.html',
  styles: [
  ]
})
export class SalesPhoneEnrollmentManualQuestionsProcessNuovoComponent implements OnInit{
  qrCode = '';
  visibleModalEndProcess = false;
  visibleModalQRProcess = true;

  @Output() step = new EventEmitter();
  @Input() phoneEnrollmentData: any;

  ngOnInit() {
    console.log(this.phoneEnrollmentData);
    this.qrCode = this.phoneEnrollmentData.nuovo.qr_code_data;
  }

  onReturnEnrollment(){
    this.step.emit('init-enrollment-nuovo');
  }

  onProgressEnrollment(){
    this.step.emit('in-progress');
  }

}
